import React from 'react';
import {FormField, requiresFieldValues} from '../model/FormField';
import SingleLayoutComponent from './shared/SingleLayoutComponent';
import FieldEditorUpdate from './editors/FieldEditorUpdate';
import ListFieldValueComponent from './ListFieldValueComponent';
import {FieldProvider} from '../contexts/FieldContext';
import ListFieldCoRuleComponent from './ListFieldCoRuleComponent';

interface Props {
  field: FormField;
}

export default function SingleFieldComponent({field}: Props) {
  const editor = <FieldEditorUpdate field={field} />;
  return (
    <FieldProvider field={field}>
      <SingleLayoutComponent label={field.field_name} editor={editor} disabled={field.disabled}>
        {requiresFieldValues(field.field_type) && <ListFieldValueComponent fieldId={field.field_id} />}
        <ListFieldCoRuleComponent fieldId={field.field_id} />
      </SingleLayoutComponent>
    </FieldProvider>
  );
}
